import styled from 'styled-components';

import { COLOR } from 'constants/color';

export const StationModal = styled.div`
  .es-modal {
    width: 600px;
    background-color: #ffffff;
  }

  .es-modal-header {
    font-size: 22px;
    line-height: 30px;
    font-weight: 500;
    color: ${COLOR.surfaceNeutralBold['neutral-11']};
    padding: 16px 18px 0 24px;
    svg {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
    svg path {
      stroke: ${COLOR.surfaceNeutralBold['neutral-11']} !important;
    }
  }

  .react-select__control {
    &:hover {
      border-color: ${COLOR.primary['primary-6']};
    }

    box-shadow: none;
  }

  .react-select__menu {
    background: 'transparent';
  }

  .react-select-container {
    width: 100%;
  }
`;
